export default function ProfileLayout() {
  return <div className="profile-layout-container"></div>
}
